"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEmptyCart = void 0;
const enums_1 = require("../../enums");
const pushToDataLayer_1 = require("../pushToDataLayer");
function trackEmptyCart() {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: 'Error',
        eventLabel: 'Empty cart',
    });
}
exports.trackEmptyCart = trackEmptyCart;
//# sourceMappingURL=trackEmptyCart.js.map